import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Badge } from '@capawesome/capacitor-badge';
import { MessageService } from 'src/app/services/message.service';
import { LocationService } from 'src/app/services/location.service';
import { ActionPerformed, PushNotificationSchema, PushNotifications, Token } from '@capacitor/push-notifications';
import { PushService } from 'src/app/services/push.service';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { CustomerService } from 'src/app/services/customer.service';
import { CustomerContact } from 'src/app/classes/customer-contact';
import { environment } from 'src/environments/environment';
import { Organization } from '../classes/organization';
import { SettingsService } from '../services/settings.service';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { PublicSettingsService } from '../services/public-settings.service';
import Locales from '../constants/locales';
import { AuthService } from '../services/auth.service';
import { LanguageSelectorComponent } from './common/language-selector/language-selector.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { City } from '../classes/city';
import { ApiService } from '../services/api.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss'],
})

export class CustomerComponent implements OnInit {
  location = ''
  messageCount = 0
  updateCount = true
  currentUser: CustomerContact = new CustomerContact()

  fa = fa
  environment = environment
  locales = Locales
  visible = false
  organization!: Organization
  isLoggedIn = false
  locale = $localize.locale
  city!: City
  balanceSubscription!: Subscription

  constructor(
    private cd: ChangeDetectorRef,
    private locationService: LocationService,
    private messageService: MessageService,
    private customerService: CustomerService,
    private pushService: PushService,
    private settingsService: SettingsService,
    private apiService: ApiService,
    private modalService: NgbModal,
    private authService: AuthService,
    private router: Router) { }

  ngOnInit() {
    this.messageService.init()
    
    if (this.apiService.organizationId()) {
      this.settingsService.organization().subscribe(organization => {
        this.visible = true
        this.organization = organization
      })
    }

    this.authService.isSignedIn().subscribe(result => {
      this.isLoggedIn = result.signed_in

      if (this.isLoggedIn) {
        this.customerService.current().subscribe(contact => {
          this.visible = true
          this.currentUser = contact
        })

        this.locationService.listen().subscribe(location => {
          this.location = location
          this.cd.detectChanges()
        })

        this.balanceSubscription = this.locationService.listenBalance().subscribe(location => {
          this.customerService.current().subscribe(contact => {
            this.currentUser = contact
            this.cd.detectChanges()
          })
        })
      }
    })

    this.messageService.unread().subscribe(async unread => {
      this.messageCount = parseInt(unread.unread)

      if (Capacitor.getPlatform() != 'web') {
        await Badge.set({ count: parseInt(unread.unread) });
      }
    })

    this.messageService.listen().subscribe(async message => {
      if (this.updateCount) {
        this.messageCount++

        if (Capacitor.getPlatform() != 'web')
          await Badge.set({ count: this.messageCount });
      }
    })

    this.messageService.listenReset().subscribe(data => {
      this.updateCount = data
      this.messageCount = 0
    })
  }

  isActive(): boolean {
    return this.router.isActive('/', {
      matrixParams: 'ignored',
      queryParams: 'ignored',
      paths: 'exact',
      fragment: 'ignored'
    });
  }


  ngOnDestroy() {
    if (this.balanceSubscription) {
      this.balanceSubscription.unsubscribe()
    }
  }

  languageSelector() {
    const modal = this.modalService.open(LanguageSelectorComponent, { centered: true, size: 'md' })
  }

  ngAfterContentChecked(): void {
    this.cd.detectChanges()
  }

  signOut() {
    if(confirm($localize`Are you sure you want to sign out?`)) {
      this.router.navigate(['/signout'])
    }
  }
}
